import { API, ENDPOINTS } from '@/app/services/api-url';

export default {
  name: 'app-switcher',
  data() {
    return {
      app: 'Home',
    };
  },
  computed: {
    accountUUID() {
      return this.$store.getters['account/getActiveAccount'].uuid;
    },
    activeApp() {
      return this.$store.getters['app/activeApp'];
    },
    activeApps() {
      return this.$store.getters['app/activeApps'];
    },
    dropdownItems() {
      return this.activeApps.map(app => app.display);
    },
  },
  watch: {
    activeApp: {
      immediate: true,
      handler(newActiveApp) {
        if (newActiveApp && this.app !== newActiveApp.display) {
          this.app = newActiveApp.display;
        }
      },
    },
  },
  methods: {
    selectApp(display) {
      if (this.app === display && this.$store.getters['app/activeApp']) {
        return;
      }
      const activeApp = this.activeApps.find(app => app.display === display);
      if (activeApp) {
        if (!activeApp.isExternal) {
          this.app = display;
          this.$store.dispatch('app/setActiveApp', activeApp.appName);
          this.$router.push(activeApp.url);
          this.$emit('app-change');
        } else {
          if (this.$route.path !== '/') {
            this.$router.push('/');
          }
          this.app = 'Home';
          this.$store.dispatch('app/setActiveApp', 'Home');
          if (activeApp.appName === 'COMPANION') {
            API.get(`${ENDPOINTS.GET_OAUTH_TOKEN}?appName=COMPANION&accountID=${this.accountUUID}`)
              .then((thisres) => {
                const token = thisres.data.data.access_token;
                const requestOptions = {
                  method: 'GET',
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                  redirect: 'follow',
                  credentials: 'include',
                };
                // the fetch gets the cookie set so the window.open works
                return fetch(activeApp.url, requestOptions);
              })
              .then((response) => { response.text(); })
              .then(() => {
                window.open(activeApp.url, '_blank', 'noopener noreferrer');
              })
              .catch((error) => { console.log(error); });
          } else {
            window.open(activeApp.url, '_blank', 'noopener noreferrer');
          }
        }
      }
    },
  },
};
